import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Beatloader from "../../../Common/BeatLoader";
import SkeletonHeroWrap from "../../../Common/skeleton/SkeletonHeroWrap/SkeletonHeroWrap";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlinePresentationChartBar } from "react-icons/hi2";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { HiOutlineMapPin } from "react-icons/hi2";
import { HiOutlineHandThumbUp } from "react-icons/hi2";
import {
    getHomeBannerData,
    getWebsiteManagementData,
} from "../../../Redux/action/MasterAction";
import Aos from "aos";
const host = process.env.REACT_APP_API_SERVER;

const StatsSection = () => {
    const navigate = useNavigate();
    const handleNavigation = () => {
        const token = localStorage.getItem("student-token");
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate("/student/dashboard");
            } else {
                navigate("/login", { state: { user: "student" } });
            }
        } else {
            navigate("/login", { state: { user: "student" } });
        }
    };

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getHomeBannerData());
    }, []);

    const {
        loadingHomeBannerDataApi,
        HomeBannerDataApiData,
        HomeBannerDataApiError,
    } = useSelector((state) => state?.MasterReducer);

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            {loadingHomeBannerDataApi ? (
                <SkeletonHeroWrap />
            ) : (
                <section className="pt-5">
                    <div className="container">
                        {/* {loadingWebsiteManagementDataListApi ?
                    <Beatloader />
                    : */}

                        <div className="row ">
                            <div className="col-lg-12">
                                <div className="stats-modern-wrapper">

                                    {HomeBannerDataApiData?.home_section_one_counter_one_count > 0 && (
                                        <div className="stats-card">
                                            <div className="stats-icon">
                                                <HiOutlineHandThumbUp />
                                            </div>
                                            <h3>
                                                <span className="counterUp">
                                                    {HomeBannerDataApiData.home_section_one_counter_one_count}
                                                </span>
                                                
                                            </h3>
                                            <p>
                                                {HomeBannerDataApiData.home_section_one_counter_one_name}
                                            </p>
                                        </div>
                                    )}

                                    {HomeBannerDataApiData?.home_section_one_counter_two_count > 0 && (
                                        <div className="stats-card">
                                            <div className="stats-icon">
                                                < HiOutlineUserGroup />
                                            </div>
                                            <h3>
                                                <span className="counterUp">
                                                    {HomeBannerDataApiData.home_section_one_counter_two_count}
                                                </span>
                                                
                                            </h3>
                                            <p>
                                                {HomeBannerDataApiData.home_section_one_counter_two_name}
                                            </p>
                                        </div>
                                    )}

                                    {HomeBannerDataApiData?.home_section_one_counter_three_count > 0 && (
                                        <div className="stats-card">
                                            <div className="stats-icon">
                                                <HiOutlineMapPin />
                                            </div>
                                            <h3>
                                                <span className="counterUp">
                                                    {HomeBannerDataApiData.home_section_one_counter_three_count}
                                                </span>
                                                
                                            </h3>
                                            <p>
                                                {HomeBannerDataApiData.home_section_one_counter_three_name}
                                            </p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>




                        {/* } */}
                    </div>
                </section>




            )}
        </>
    );
};

export default StatsSection;
